var WDN = WDN || {};

if (typeof WDN.Countdown === "undefined") {
  WDN.Countdown = (function () {
    var Countdown;

    Countdown = function (config) {
      this.config = config;
      this.targetDate = new Date(config.date);
      this.outputContainer = document.querySelector("[data-countdown='" + config.id + "']");
      this.translations = WDN.Translations.countdown;
      if (!this.outputContainer) return;
      this.init();
    };

    Countdown.prototype.calculate = function () {
      this.timeDifference = this.targetDate.getTime() - new Date().getTime();
      // calculating difference based on two dates
      this.days = Math.floor(parseFloat(this.timeDifference / (1000 * 60 * 60 * 24)));
      this.hours = Math.floor((this.timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((this.timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((this.timeDifference % (1000 * 60)) / 1000);

      this.rawDays = this.days < 0 ? 0 : this.days;
      this.rawHours = this.hours < 0 ? 0 : this.hours;
      this.rawMinutes = this.minutes < 0 ? 0 : this.minutes;
      this.rawSeconds = this.seconds < 0 ? 0 : this.seconds;

      this.days = this.formatTime(this.days);
      this.hours = this.formatTime(this.hours);
      this.minutes = this.formatTime(this.minutes);
      this.seconds = this.formatTime(this.seconds);
    };

    Countdown.prototype.formatTime = function (time) {
      // if requested time is negative - set is as 0 instead
      time = time < 0 ? 0 : time;

      // converting time to string
      var stringTime = "" + time;

      // checking if is single digit number
      if (stringTime.length === 1) {
        stringTime = "0" + stringTime;
      }

      return stringTime;
    };

    Countdown.prototype.getFormattedOutput = function () {
      var tk = this.translations;
      var output = [this.days + tk.days, this.hours + tk.hours, this.minutes + tk.minutes, this.seconds + tk.seconds];
      if (this.config.hideDays) {
        var output = [this.hours + tk.hours, this.minutes + tk.minutes, this.seconds + tk.seconds];
      }
      return output.join(tk.divider);
    };

    Countdown.prototype.render = function () {
      if (this.config.boxes) {
        this.renderBoxes();
        return;
      }
      this.outputContainer.innerHTML = this.getFormattedOutput();
    };

    Countdown.prototype.renderBoxes = function () {
      var units = { days: this.rawDays, hours: this.rawHours, minutes: this.rawMinutes, seconds: this.rawSeconds };
      for (var unit in units) {
        var box = this.outputContainer.querySelector("[data-countdown-" + unit + "]");
        if (box) box.textContent = units[unit];
      }
      if (!this.spacingSet) {
        this.updateSpacing();
        this.spacingSet = true;
      }
    };

    Countdown.prototype.updateSpacing = function () {
      // Boxes sit edge-to-edge with a flex gap, but each label is centered
      // and absolutely positioned under its own box, so it can overhang past
      // the box on both sides. Checks every ADJACENT pair using THEIR OWN
      // box widths (a 1-digit "Days" box is narrower than a 2-digit "Hours"
      // box, so a shared/global box width would misjudge that pair).
      var units = this.outputContainer.querySelectorAll(".announcementCountdownUnit");
      var boxWidths = [];
      var labelWidths = [];
      for (var i = 0; i < units.length; i++) {
        var box = units[i].querySelector(".announcementCountdownBox");
        var label = units[i].querySelector(".announcementCountdownLabel");
        boxWidths.push(box ? box.getBoundingClientRect().width : 0);
        labelWidths.push(label ? label.getBoundingClientRect().width : 0);
      }
      var neededGap = 0;
      for (var j = 0; j < labelWidths.length - 1; j++) {
        var pairNeed = (labelWidths[j] + labelWidths[j + 1]) / 2 - (boxWidths[j] + boxWidths[j + 1]) / 2;
        neededGap = Math.max(neededGap, pairNeed);
      }
      var buffer = 6;
      var gap = Math.max(neededGap, 0) + buffer;
      this.outputContainer.style.setProperty("--countdown-gap", gap + "px");
    };

    Countdown.prototype.handleInterval = function () {
      if (this.timeDifference < 0) {
        this.stop();
        this.handleVisibility();
        return;
      }
      this.calculate();
      this.render();
    };

    Countdown.prototype.handleVisibility = function () {
      if (this.config.hideOnEnd) {
        this.outputContainer.classList.add("hidden");
      }

      if (this.config.hideParentOnEnd) {
        if (this.config.largeCountdown) {
          document.body.querySelector('.countdownLarge').classList.add('hidden');
        } else {
          this.outputContainer.parentNode.classList.add("hidden");
        }
      }
    };

    Countdown.prototype.start = function () {
      this.timer = setInterval(this.handleInterval.bind(this), 1000);
    };

    Countdown.prototype.stop = function () {
      clearInterval(this.timer);
      this.dispatchEndEvent();
    };

    Countdown.prototype.dispatchEndEvent = function () {
      this.outputContainer.dispatchEvent(
        new CustomEvent("countdown:completed", {
          detail: this,
        })
      );
    };

    Countdown.prototype.init = function () {
      // calculates time difference based on config
      this.calculate();
      // outputs countdown
      this.render();

      if (this.timeDifference < 0) {
        this.handleVisibility();
        return;
      }
      // countown interval starts here
      this.start();
    };

    return Countdown;
  })();
}
